var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicatorRoundtrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 36,
    viewBox: "0 0 16 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 3.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 32,
    r: 3.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65602 13.3284C8.65602 12.9602 8.9545 12.6617 9.32269 12.6617C9.56095 12.6617 9.77002 12.7867 9.88791 12.9747L11.6797 14.7665C11.94 15.0268 11.94 15.4489 11.6797 15.7093C11.4193 15.9696 10.9972 15.9696 10.7368 15.7093L9.98936 14.9618L9.98936 19.9951C9.98936 20.3633 9.69088 20.6617 9.32269 20.6617C8.9545 20.6617 8.65602 20.3633 8.65602 19.9951L8.65602 13.3614C8.65594 13.3553 8.65594 13.3492 8.65602 13.3431V13.3284Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34389 22.6717C7.34389 23.0399 7.04541 23.3383 6.67722 23.3383C6.43896 23.3383 6.22989 23.2133 6.11201 23.0254L4.32026 21.2336C4.05991 20.9733 4.05991 20.5512 4.32026 20.2908C4.58061 20.0305 5.00272 20.0305 5.26307 20.2908L6.01056 21.0383L6.01056 16.005C6.01056 15.6368 6.30903 15.3383 6.67722 15.3383C7.04541 15.3383 7.34389 15.6368 7.34389 16.005L7.34389 22.6387C7.34397 22.6448 7.34397 22.6509 7.34389 22.6569V22.6717Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorRoundtrip);
export default __webpack_public_path__ + "static/media/indicator-roundtrip.595c7cfe.svg";
export { ForwardRef as ReactComponent };